import React from 'react'

import RightDatesSection from '../../../ReusableSections/RightDatesSection'
import SocialMediaAccountsSection from '../../../ReusableSections/SocialMediaAccountsSection'
import BrandKeywordsSection from '../../../ReusableSections/BrandKeywordsSection'
import RightAllocationAndDelivery from '../../../ReusableSections/RightAllocationAndDelivery'
import RequestAssetsSection from '../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../ReusableSections/ActionsOrCommentsSection'

function PostsRightCreateSections({ formik }) {
  return (
    <>
      <RightDatesSection formik={formik} />
      <SocialMediaAccountsSection formik={formik} />
      <BrandKeywordsSection formik={formik} />
      <RightAllocationAndDelivery
        formik={formik}
        sectionDescription="Please enter the number of social posts to be provided under this right."
        showUnitsField={false}
      />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default PostsRightCreateSections
